import React, { useEffect, useState } from "react";
import { CirclePower } from "lucide-react";
import { SyncBadge } from "../../common/badges";

const OnOff1Widget = ({ widget, onValueUpdate, pattern }) => {
  const [isOn, setIsOn] = useState(false);
  const [v0, setV0] = useState();

  useEffect(() => {
    setV0(widget);
    if (widget?.items?.$w1) {
      if (widget.items.$w1.value === "on") {
        setIsOn(true);
      } else {
        setIsOn(false);
      }
    }
    return () => {};
  }, [widget]);

  const handleValueUpdate = (data) => {
    const updatedWidget = {
      ...v0.items.$w1,
      value: data ? "on" : "off",
    };
    onValueUpdate(updatedWidget);
  };

  const handleToggle = () => {
    const newValue = !isOn;
    setIsOn(newValue);
    handleValueUpdate(newValue);
  };

  return (
    <div className="w-full h-full flex items-center relative">
      <div
        className="h-full aspect-square flex items-center justify-center relative"
        style={{
          cursor: pattern && pattern.endsWith("_R") ? "default" : "pointer",
          opacity: pattern && pattern.endsWith("_R") ? 0.8 : 1,
        }}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          if (pattern && pattern.endsWith("_R")) return;
          handleToggle();
        }}
      >
        <CirclePower
          size="100%"
          color={isOn ? "#FFD700" : "#B0B0B0"}
          fill={isOn ? "#FFD700" : "#B0B0B0"}
          fillOpacity={0.2}
          strokeWidth={2}
          style={{
            width: "100%",
            height: "100%",
          }}
        />
        {pattern && pattern.endsWith("_W") && <SyncBadge />}
      </div>
    </div>
  );
};

export default OnOff1Widget;
